const translations = {
  "en": {
    "· Next Payment:": "· Next Payment:",
    "Cancel Subscription": "Cancel Subscription",
    "Manage": "Manage",
    "Manage on Apple": "Manage on Apple",
    "Manage on google": "Manage on google",
    "No auto-renewing subscriptions": "No auto-renewing subscriptions"
  },
  "zh-tw": {
    "· Next Payment:": "· 下次付款：",
    "Cancel Subscription": "取消訂閱",
    "Manage": "管理",
    "Manage on Apple": "在 Apple 管理",
    "Manage on google": "在 Google 管理",
    "No auto-renewing subscriptions": "無自動續訂項目"
  }
};

export default translations;
